import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cohrex-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TextareaComponent {
  private _startIcon?: string;
  @Input()
  set startIcon(value: string | undefined) {
    this._startIcon = value;
  }
  get startIcon(): string | undefined {
    return this._startIcon;
  }

  private _endIcon?: string;
  @Input()
  set endIcon(value: string | undefined) {
    this._endIcon = value;
  }
  get endIcon(): string | undefined {
    return this._endIcon;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }
  get isError(): boolean | undefined {
    return this._isError;
  }

  private _disabled?: boolean = false;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  @Input() width: string = 'w-full';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() rows: string = '5';
}
